import React from 'react';

const RAIL_CONFIG: Record<string, { label: string; color: string; bg: string; icon: string }> = {
  usdc: { label: 'USDC',  color: '#2775CA', bg: '#EAF1FF', icon: '$'  },
  sol:  { label: 'SOL',   color: '#14A78B', bg: '#E6F7F4', icon: '◎'  },
  usdt: { label: 'USDT',  color: '#26A17B', bg: '#E6F5EF', icon: '₮'  },
  whop: { label: 'Whop',  color: '#5E46A7', bg: '#F0EDF9', icon: 'W'  },
};

interface RailTabProps {
  rail: string;
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export const RailTab: React.FC<RailTabProps> = ({ rail, active = false, onClick, disabled = false }) => {
  const cfg = RAIL_CONFIG[rail] ?? { label: rail, color: '#6B7280', bg: '#F3F4F6', icon: '?' };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className='flex-1 flex flex-col items-center gap-1.5 py-3 px-2 rounded-md border transition-colors text-xs font-medium relative'
      style={{
        borderColor: active ? 'var(--pp-border-strong)' : 'var(--pp-border)',
        background: active ? 'var(--pp-surface)' : 'transparent',
        color: active ? 'var(--pp-text)' : 'var(--pp-text-muted)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        outline: 'none',
        boxShadow: active ? 'inset 0 2px 0 0 ' + cfg.color : 'none',
      }}
    >
      <span
        className='w-8 h-8 rounded-full flex items-center justify-center text-base font-semibold'
        style={{ background: 'var(--pp-subtle)', color: cfg.color }}
      >
        {cfg.icon}
      </span>
      {cfg.label}
    </button>
  );
};

export default RailTab;
